import styled from 'styled-components';
import {
  gridColumn,
  gridRow,
  gridArea,
  GridColumnProps,
  GridRowProps,
  GridAreaProps,
} from 'styled-system';
import { typeHelpers } from '@polymathnetwork/new-shared';
import { Box } from '~/components/Box';

export type ItemProps = typeHelpers.GetProps<typeof Box> &
  GridColumnProps &
  GridRowProps &
  GridAreaProps;

export const Item = styled(Box)<ItemProps>`
  ${gridColumn};
  ${gridRow};
  ${gridArea};
`;
try {
    // @ts-ignore
    Item.displayName = "Item";
    // @ts-ignore
    Item.__docgenInfo = { "description": "", "displayName": "Item", "props": { "theme": { "defaultValue": null, "description": "", "name": "theme", "required": false, "type": { "name": "any" } }, "as": { "defaultValue": null, "description": "Typing Note: prefer using .withComponent for now as it is actually type-safe.\n\nString types need to be cast to themselves to become literal types (as={'a' as 'a'}).", "name": "as", "required": false, "type": { "name": "\"symbol\" | \"object\" | \"a\" | \"abbr\" | \"address\" | \"area\" | \"article\" | \"aside\" | \"audio\" | \"b\" | \"base\" | \"bdi\" | \"bdo\" | \"big\" | \"blockquote\" | \"body\" | \"br\" | \"button\" | \"canvas\" | ... 154 more ... | FunctionComponent<...>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/Grid/Item/index.tsx#Item"] = { docgenInfo: Item.__docgenInfo, name: "Item", path: "src/components/Grid/Item/index.tsx#Item" };
}
catch (__react_docgen_typescript_loader_error) { }